import React, { useEffect, useState } from 'react'
import { Outlet } from 'react-router'
import Context from './Context'
import { checkJwt, incrementConnection } from './services'
import LoadingPage from '@shared/pages/LoadingPage'

function PrivateApp() {
  const [ratpId, setRatpId] = useState(null)
  const isAuthenticated = () => localStorage.getItem('jwt-token')

  useEffect(() => {
    if (!isAuthenticated()) {
      window.location.assign('/api/auth/login?redirectPath=' + window.location.pathname)
    }
  })

  useEffect(() => {
    if (!ratpId) {
      checkJwt().then(resp => {
        resp && setRatpId(resp)
      })
    }
    incrementConnection()
  }, [])

  if(!ratpId) {
    return <LoadingPage/>
  }

  return <Context>
    <Outlet />
  </Context>
}

export default PrivateApp
